const ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

export function isBase62(str: string): boolean {
  return str.match(/^[0-9a-zA-Z]+$/) !== null;
}
export function encode(number: bigint | number): string {
  if (number === undefined) throw new Error("number must be defined");
  if (number === null     ) throw new Error("number must be defined");

  if (typeof number === "number") return encode(BigInt(number));

  if (number < 1n         ) throw new Error("number must be positive");

  let result = "";
  let remaining = number;

  while (remaining > 0n) {
    const digit = Number(remaining % 62n);
    result = ALPHABET[digit] + result;
    remaining = remaining / 62n;
  }

  return result;
}
export function decode(str: string): bigint {
  if (str === undefined) throw new Error("str must be defined");
  if (str === null     ) throw new Error("str must be defined");
  if (str.length === 0 ) throw new Error("str must not be empty");
  if (!isBase62(str)   ) throw new Error("str must be a valid base62 string containing only alphanumeric characters");

  let result = 0n;

  for (let i = 0; i < str.length; i++) {
    const digit = str[i];
    const value = BigInt(ALPHABET.indexOf(digit));
    result = result * 62n + value;
  }

  return result;
}
